import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})

export class BreadcrumbComponent implements OnInit {

  @Input() activeRouteName;
  @Input() navigationRoutes;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  navigateTo(navigateTo) {
    this.router.navigate(navigateTo);
  }

}
